(function () {
  "use strict";

  var PLACEHOLDER = "اختر خيارًا";

  function forms() {
    return Array.prototype.slice.call(document.querySelectorAll('form[data-type="add-to-cart-form"]'));
  }

  function selectOf(form) {
    var select = form.querySelector('select[name="id"]');
    return select;
  }

  function groups(form) {
    return Array.prototype.slice.call(form.querySelectorAll("[data-swatch-option]")).filter(function (group) {
      return group.querySelector("[data-swatch-item]") || group.querySelector("select");
    });
  }

  function variants(form) {
    var node = form.querySelector(".pr_variants_json");
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || "[]");
    } catch (error) {
      return [];
    }
  }

  function swatchItems(group) {
    return Array.prototype.slice.call(group.querySelectorAll("[data-swatch-item]"));
  }

  function selectedValues(form) {
    return groups(form).map(function (group) {
      var selected = group.querySelector("[data-swatch-item].is--selected");
      if (selected) return String(selected.getAttribute("data-value") || "");

      var optionSelect = group.querySelector('select:not([name="id"])');
      if (optionSelect && optionSelect.value) return String(optionSelect.value);

      var current = group.querySelectorAll("[data-current-value]");
      if (current && current.textContent.trim() !== PLACEHOLDER) return current.textContent.trim();

      return "";
    });
  }

  function findVariant(form, values) {
    if (!values.length || values.some(function (value) { return !value; })) return null;
    return variants(form).find(function (variant) {
      return values.every(function (value, index) {
        return String(variant["option" + (index + 1)] || "") === value;
      });
    }) || null;
  }

  function setGroup(group, item) {
    swatchItems(group).forEach(function (node) {
      node.classList.toggle("is--selected", node === item);
    });

    Array.prototype.forEach.call(group.querySelectorAll('input[type="radio"]'), function (radio) {
      radio.checked = !!item && radio.id === item.getAttribute("for");
    });

    var current = group.querySelectorAll("[data-current-value]");
    Array.prototype.forEach.call(current, function (node) { node.textContent = item ? (item.getAttribute("data-value") || "") : PLACEHOLDER; });
  }

  function setGroups(form, variant) {
    if (!variant) return;
    groups(form).forEach(function (group, index) {
      var value = String(variant["option" + (index + 1)] || "");
      var item = swatchItems(group).find(function (node) {
        return String(node.getAttribute("data-value") || "") === value;
      });
      if (item) setGroup(group, item);
    });
  }

  function clearGroups(form) {
    groups(form).forEach(function (group) {
      setGroup(group, null);
      Array.prototype.forEach.call(group.querySelectorAll("select"), function (select) {
        if (select.querySelector('option[value=""]')) select.value = "";
      });
    });
  }

  function clearSelect(select) {
    if (!select) return;
    select.value = "";
    Array.prototype.forEach.call(select.options, function (option) {
      option.selected = option.value === "";
    });
  }

  function buyNow(form, enabled) {
    var payment = form.querySelector(".shopify-payment-button");
    if (!payment) return;

    payment.hidden = !enabled;
    payment.style.setProperty("display", enabled ? "block" : "none", "important");

    Array.prototype.forEach.call(
      payment.querySelectorAll("shopify-accelerated-checkout, shopify-buy-it-now-button"),
      function (host) {
        if (enabled) host.removeAttribute("disabled");
        else host.setAttribute("disabled", "");
        try { host.disabled = !enabled; } catch (error) {}
        if (host.shadowRoot) {
          Array.prototype.forEach.call(host.shadowRoot.querySelectorAll("button"), function (button) {
            button.disabled = !enabled;
            button.setAttribute("aria-disabled", String(!enabled));
          });
        }
      }
    );
  }

  function buttons(form, variant) {
    var ready = !!variant && variant.available !== false;
    var addButton = form.querySelector('[type="submit"][name="add"]');
    var addText = addButton && addButton.querySelector(".t4s-btn-atc_text");

    if (addButton) {
      addButton.disabled = !ready;
      if (ready) {
        addButton.removeAttribute("aria-disabled");
        addButton.setAttribute("data-atc-form", "");
      } else {
        addButton.setAttribute("aria-disabled", "true");
        addButton.removeAttribute("data-atc-form");
      }
    }

    if (addText) {
      var strings = window.T4SProductStrings || {};
      addText.textContent = ready ? (strings.addToCart || "أضف إلى السلة") : PLACEHOLDER;
    }

    Array.prototype.forEach.call(
      document.querySelectorAll('[data-sticky-addtocart] [data-action-atc], [data-sticky-addtocart] [type="submit"][name="add"]'),
      function (button) {
        button.disabled = !ready;
        button.setAttribute("aria-disabled", String(!ready));
        if (ready && variant) {
          button.setAttribute("data-variant-id", String(variant.id));
          button.setAttribute("data-action-atc", "");
        } else {
          button.removeAttribute("data-action-atc");
          button.removeAttribute("data-variant-id");
        }
      }
    );

    buyNow(form, ready);
  }

  function setVariant(form, variant) {
    var select = selectOf(form);
    if (!select) return;

    if (variant) {
      select.value = String(variant.id);
      Array.prototype.forEach.call(select.options, function (option) {
        option.selected = option.value === String(variant.id);
      });
      select.dispatchEvent(new Event("change", { bubbles: true }));
    } else {
      clearSelect(select);
    }
  }

  function sync(form) {
    var values = selectedValues(form);
    var variant = findVariant(form, values);

    if (variant) {
      setVariant(form, variant);
      buttons(form, variant);
    } else {
      setVariant(form, null);
      buttons(form, null);
    }
  }

  function resetManualForm(form) {
    var select = selectOf(form);
    if (!select) return false;

    clearGroups(form);
    clearSelect(select);
    buttons(form, null);
    form.setAttribute("data-manual-variant-picker", "true");
    return true;
  }

  function hasVariantParameter() {
    try {
      return new URL(window.location.href).searchParams.has("variant");
    } catch (error) {
      return false;
    }
  }

  function removeVariantParameter() {
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has("variant")) return;
      url.searchParams.delete("variant");
      var next = url.pathname + (url.searchParams.toString() ? "?" + url.searchParams.toString() : "") + url.hash;
      window.history.replaceState(window.history.state, document.title, next);
    } catch (error) {}
  }

  function initialize() {
    var hasIncomingVariant = hasVariantParameter();

    forms().forEach(function (form) {
      if (!selectOf(form)) return;
      if (hasIncomingVariant || !form.hasAttribute("data-manual-variant-initialized")) {
        resetManualForm(form);
        form.setAttribute("data-manual-variant-initialized", "true");
      } else {
        buttons(form, null);
      }
    });

    if (hasIncomingVariant) removeVariantParameter();
  }

  document.addEventListener("click", function (event) {
    var item = event.target.closest && event.target.closest("[data-swatch-item]");
    if (!item) return;

    var form = item.closest('form[data-type="add-to-cart-form"]');
    var group = item.closest("[data-swatch-option]");
    if (!form || !group || !selectOf(form)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    setGroup(group, item);
    sync(form);
    var closeButton = group.querySelector("[data-dropdown-close]");
    if (closeButton) closeButton.click();
  }, true);

  document.addEventListener("change", function (event) {
    var form = event.target.closest && event.target.closest('form[data-type="add-to-cart-form"]');
    if (!form || !selectOf(form)) return;

    if (event.target === selectOf(form)) {
      var currentVariant = findVariant(form, selectedValues(form));
      if (currentVariant) buttons(form, currentVariant);
      else {
        clearSelect(selectOf(form));
        buttons(form, null);
      }
      return;
    }

    if (event.target.matches && event.target.matches("select")) sync(form);
  }, true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize);
  } else {
    initialize();
  }

  window.setTimeout(initialize, 250);
  window.setTimeout(initialize, 1000);

  if (window.MutationObserver && document.body) {
    new MutationObserver(function () {
      forms().forEach(function (form) {
        if (selectOf(form) && !form.hasAttribute("data-manual-variant-initialized")) {
          resetManualForm(form);
          form.setAttribute("data-manual-variant-initialized", "true");
        }
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();